<template>
  <Catalogs
    title="Маркетинговые источники"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'MarketingSourceAdd'"
    :route-edit="'MarketingSourceEdit'"
    :route-view="'MarketingSourceView'"
    :route-path="'/marketing_sources'"
    :can-edit="canEditMarketingSourceCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
   import Catalogs from "../Catalogs.vue";

export default {
  name: "MarketingSources",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getMarketingSources(data);
    },
    canEditMarketingSourceCatalogs() {
      return this.hasPermission([PERM.CATALOG_SOURCE_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/MarketingSources/MarketingSources.vue